import { Link } from "react-router-dom";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  tone?: "light" | "dark";
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
  tone = "light",
}: SectionHeadingProps) {
  const isDark = tone === "dark";

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p
            className={`mb-2 flex items-center gap-2 text-xs tracking-[0.2em] ${
              isDark ? "text-accent-300" : "text-accent-600"
            }`}
          >
            <span className="h-px w-6 bg-current"></span>
            {eyebrow}
          </p>
        )}
        <h2
          className={`font-heading text-xl font-semibold tracking-tight md:text-2xl ${
            isDark ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {description && (
          <p
            className={`mt-2 text-sm leading-relaxed ${
              isDark ? "text-background-300" : "text-foreground-600"
            }`}
          >
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className={`group inline-flex shrink-0 cursor-pointer items-center gap-1 text-sm transition ${
            isDark
              ? "text-background-200 hover:text-accent-300"
              : "text-primary-600 hover:text-accent-600"
          }`}
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
        </Link>
      )}
    </div>
  );
}